import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, KeepAlive as _KeepAlive, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_create_api_key_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Create API Key", -1)
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_create_api_key_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_create_api_key_header",
  "data-kt-scroll-wrappers": "#kt_modal_create_api_key_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6" }
const _hoisted_12 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Please Note!"),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createTextVNode(" API key limits and scopes are determined by your selected "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, " plan.")
    ])
  ])
], -1)
const _hoisted_14 = { class: "mb-5 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "API Key Name", -1)
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = {
  key: 0,
  class: "my-8"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h6", null, "Fees", -1)
const _hoisted_20 = { class: "modal-footer flex-center" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "indicator-label" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_PlansList = _resolveComponent("PlansList")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.$modals.API_KEY_MODAL,
    ref: "createAPIKeyModalRef",
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            id: `${_ctx.$modals.API_KEY_MODAL}_close`,
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ], 8, _hoisted_6)
        ]),
        _createVNode(_component_Form, {
          id: "kt_modal_create_api_key_form",
          ref: "formRef",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_ctx.activeView === _ctx.View.PLANS)
                    ? (_openBlock(), _createBlock(_component_PlansList, {
                        key: 0,
                        plans: _ctx.plans,
                        plan: _ctx.apiData.plan,
                        "onUpdate:plan": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apiData.plan) = $event))
                      }, null, 8, ["plans", "plan"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                          ]),
                          _hoisted_13
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "Your API Name",
                            name: "name",
                            modelValue: _ctx.apiData.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.apiData.name) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_ErrorMessage, { name: "name" })
                            ])
                          ])
                        ])
                      ]))
                ], 1024))
              ]),
              (_ctx.isPlansVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("small", null, _toDisplayString(_ctx.fees), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.isPlansVisible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-white me-3",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeView = _ctx.View.FORM))
                  }, " Back "))
                : _createCommentVNode("", true),
              (_ctx.isPlansVisible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    ref: "submitButtonRef",
                    type: "submit",
                    id: "kt_modal_create_api_key_submit",
                    class: "btn btn-primary",
                    disabled: !_ctx.apiData.plan
                  }, [
                    _createElementVNode("span", _hoisted_22, " Pay " + _toDisplayString(_ctx.$filters.formatCurrency(_ctx.totalPrice, "usd")), 1),
                    _hoisted_23
                  ], 8, _hoisted_21))
                : (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    id: "kt_modal_create_api_key_submit",
                    class: "btn btn-primary",
                    disabled: !_ctx.apiData.name || _ctx.loading,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeView = _ctx.View.PLANS))
                  }, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.loading ? "Loading plans" : "Select Plan"), 1)
                  ], 8, _hoisted_24))
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 8, _hoisted_1))
}